import React, { useContext } from "react";
import Topbar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import { Container, Nav, Tab, Tabs } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import CheckBox from "../../../components/CheckBox/CheckBox";
import { SettingsPermissionContext } from "../SettingsPermissionView";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import UploadIcon from "../../../assets/images/uploadIcon.svg";
import { baseURL } from "../../../api/Axios";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import "./settingsPermission.css";
import { Spinner } from "react-bootstrap";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
const testInput = () => <input />;

const SettingsPermission = ({ textContent }) => {
  const {
    navigateToDeviceSettings,
    navigateToRoleManagement,
    goBack,
    showAlert,
    setShowAlert,
    updatePermission,
    rolesNames,
    tableData,
    handleAlertSubmit,
    submitUpdatedData,
    spinnerStatus,
    alertMessage,
    setAlertMessage,
    logout,
    statusCode,
    handleMagneticUpload,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    cardFileDownload,
    extentendStayValue,
    setExtentendStayValue,
    submitExtentedStayData,
    setExtentedStayRequired,
    naviagte,
    getExtentedStayValue,
    extentedSpinnerStatus,
  } = useContext(SettingsPermissionContext);

  const requiredKey = "device-settings";
  const changeToDeviceSettings = (tab) => {
    tab === requiredKey ? navigateToDeviceSettings() : null;
    getExtentedStayValue();
  };
  const extentedTimeList = [
    {
      id: 1,
      name: "9",
    },
    // {
    //   id: 2,
    //   name: "8",
    // },
    {
      id: 3,
      name: "10",
    },
    {
      id: 4,
      name: "11",
    },
    {
      id: 5,
      name: "12",
    },
    {
      id: 6,
      name: "13",
    },
    {
      id: 7,
      name: "14",
    },

    {
      id: 8,
      name: "15",
    },

    {
      id: 9,
      name: "16",
    },

    {
      id: 10,
      name: "17",
    },
    {
      id: 11,
      name: "18",
    },

    {
      id: 12,
      name: "19",
    },
    {
      id: 13,
      name: "20",
    },
    {
      id: 14,
      name: "21",
    },
    {
      id: 15,
      name: "22",
    },
    {
      id: 16,
      name: "13",
    },
    {
      id: 17,
      name: "14",
    },

    {
      id: 18,
      name: "15",
    },
    {
      id: 19,
      name: "16",
    },
    {
      id: 20,
      name: "17",
    },

    {
      id: 21,
      name: "18",
    },
    {
      id: 22,
      name: "19",
    },
    {
      id: 23,
      name: "20",
    },

    {
      id: 24,
      name: "21",
    },
    {
      id: 25,
      name: "22",
    },
    {
      id: 26,
      name: "23",
    },

    {
      id: 27,
      name: "24",
    },
  ];

  const handleCancel = () => {
    // console.log("Cancelled");
    // naviagte(-1);
    // Add your cancel logic here
  };
  return (
    <div className="settings">
      <Topbar />
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => handleAlertSubmit()
        }
      />
      <Container className="my-4">
        <Tabs
          onSelect={(e) => {
            changeToDeviceSettings(e);
          }}
          defaultActiveKey="permissions"
          id="uncontrolled-tab-example"
        >
          <Tab
            eventKey="permissions"
            title={textContent.permissions.toUpperCase()}
          >
            <div className="heading-row my-3">
              <div className="title-box">
                <img
                  onClick={() => {
                    goBack();
                  }}
                  id="arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={22}
                />
                <p className="title-name">{textContent.permissions}</p>
              </div>
              <Button
                onClick={() => {
                  navigateToRoleManagement();
                }}
                text={textContent.roleManagement.toUpperCase()}
              />
            </div>

            <div className="permissions">
              <DataTable
                tableData={tableData?.length > 0 ? tableData : []}
                header={
                  rolesNames?.length > 0
                    ? rolesNames
                    : [{ title: "", prop: "" }]
                }
                isPagination={false}
              />
            </div>

            <div className="settings-permissions-modifications">
              <Button
                text={textContent.cancel}
                onClick={() => {
                  goBack();
                }}
              />

              <Button
                text={spinnerStatus ? <Spinner size="sm" /> : textContent.save}
                onClick={() => submitUpdatedData()}
              />
            </div>
          </Tab>
          <Tab eventKey="visitor-card" title="VISITORS CARD">
            <div className="heading-row my-3">
              <div className="title-box">
                <img
                  className="back-arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={17}
                  onClick={() => goBack()}
                />
                <p className="title-name">{textContent.magneticTitle}</p>
              </div>
              <p className={"download-text"}>
                <a
                  className={"excel-download"}
                  href={
                    cardFileDownload
                      ? `${baseURL}/excel/${cardFileDownload}`
                      : null
                  }
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  Download Visitors Card
                </a>
              </p>
            </div>
            <form onSubmit={visitorCardSubmit} className="uploadCradSection">
              <div className="uploadMagneticCardData">
                <label className="uploadPhotoContainerGuest">
                  <img src={UploadIcon} alt="img" />
                  <span className="uploadTextRegister">
                    {cardExcel ? cardExcel : "UPLOAD"}
                  </span>
                  <input
                    className="input-group-text"
                    type={"file"}
                    onChange={handleMagneticUpload}
                  />
                </label>
                <p className="mb-0 error-msg">
                  {fileErrorMessage ? fileErrorMessage : ""}
                </p>
              </div>
              <div className="fileSubmitBtns">
                <button type="submit" className="button">
                  {spinnerStatus ? <Spinner size="sm" /> : "Submit"}
                </button>
              </div>
            </form>
          </Tab>
          <Tab
            eventKey="device-settings"
            title={textContent.deviceSettings.toUpperCase()}
          ></Tab>
          {/* // new changed */}
          
            <Tab eventKey="extented-stay" title="EXTENTED STAY">
              <div className="heading-row my-3">
                <div className="title-box">
                  <img
                    onClick={() => goBack()}
                    className="back-arrow"
                    src={BackArrow}
                    alt="Back Arrow"
                    width={22}
                  />
                  <p className="title-name">Extended Stay Settings</p>
                </div>
              </div>

              <form
                onSubmit={submitExtentedStayData}
                className="extentedsection"
              >
                <div className="extendstaymaindiv">
                  <div className="extentedsectiondropdown drop-item error-alert dropdown">
                    <label className="extentedlabel">Extended Hour</label>
                    <DropDownItem
                      list={extentedTimeList}
                      selectedItem={extentendStayValue}
                      setSelectedItem={setExtentendStayValue}
                      categoryRequired={setExtentedStayRequired}
                    />
                  </div>
                  <div className="button-group-extented">
                    <button type="submit" className="extentedSaveBtn">
                      Save
                    </button>
                  </div>
                </div>
              </form>
              {extentedSpinnerStatus && (
                <div className="spinner-overlay">
                  <Spinner size="xl" className="custom-spinner" />
                </div>
              )}
            </Tab>
        
        </Tabs>
      </Container>
    </div>
  );
};

export default SettingsPermission;
